import Link from '../../views/Help';
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickOKHandler: value => {
      // console.log(value);
      window.close();
    }
  };
};

const Help = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Help;



// WEBPACK FOOTER //
// ./src/components/container/Help/index.js